import { Box, Button, Card, CardContent, Chip, Container, Link, Typography } from "@mui/material";
import { FC, UIEvent, useEffect, useRef, useState } from "react";

import { Download } from "@mui/icons-material";
import MaterialReactTable from "material-react-table";
import { useHistory } from "react-router-dom";
import { getConfigs } from "../../configs";
import { API_SLUGS, ISSUE_STATE_OPTIONS, ROUTES } from "../../constants";
import { useTableInfinity } from "../../hooks/process/useTableInfinity";
import { UserCircle } from "../../icons/user-circle";
import { downloadCSV } from "../../utils/downlodCSV";
import FaultGroups from "../common/faultGroups";
import TruncatedScrollingText from "../common/truncatedScrollingText";

const limit = 30;
const disableInfiniteScroll = false;

const IssueReport: FC<any> = ({ groupId, projectId, maxHeight = "calc(100vh - 320px)" }) => {
    const issuesUrl = API_SLUGS.ISSUES_REPORT + `?limit={limit}&offset={offset}`;
    const tableContainerRef = useRef<HTMLDivElement>(null);

    const [columnHeaderFilter, setColumnHeaderFilter] = useState<any>({});
    const [isDownloading, setIsDownloading] = useState(false);

    const { rows, fetchMoreOnBottomReached, isFetching } = useTableInfinity(
        "issues",
        issuesUrl,
        tableContainerRef,
        limit
    );


    const downloadCSVReport = async () => {
        setIsDownloading(true);
        await downloadCSV(`${getConfigs().baseApiUrl}${API_SLUGS.ISSUES_REPORT}?downloadCsv=true`, `aptori_issues_issue_report`)
        setIsDownloading(false);
    };

    useEffect(() => {
        if (!disableInfiniteScroll) {
            fetchMoreOnBottomReached(tableContainerRef.current);
        }
    }, [fetchMoreOnBottomReached])

    const navigate = useHistory();
    return (
       
            <Box
                sx={{
                    backgroundColor: "background.paper",
                    minHeight: '100%',

                }}
            >
                <Container maxWidth={false} sx={{ p: 3, pt: 1.5 }}>
                        <Box>
                            <Box sx={{ display: "flex", justifyContent: "end", pb: 2 }}>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => !isDownloading && downloadCSVReport()}
                                    sx={{ color: "text.primary", borderColor: "neutral.300" }}
                                >
                                    <Box sx={{ display: "flex", justifyContent: "start" }}>
                                        <Download fontSize="small" />
                                        Download CSV Report

                                    </Box>
                                </Button>
                            </Box>
                            <Box
                                sx={{flexGrow :1}}
                            >
                                <MaterialReactTable muiTablePaperProps={{
                                    elevation: 0
                                }} enableGlobalFilter={false}
                                    columns={[
                                        {
                                            accessorKey: "findingType",
                                            header: "Type",
                                            Cell: (params: any) => (
                                                <Chip
                                                    label={params?.row?.original?.findingType}
                                                    size="small"
                                                />
                                            ),

                                            size: 100,

                                        },
                                        {
                                            accessorKey: "id",
                                            header: "ID",
                                            Cell: (params: any) => (
                                                <Link
                                                    onClick={() => {
                                                        navigate.push(
                                                            `/findings?issueId=${params.row?.original?.id}`
                                                        );
                                                    }}
                                                >
                                                    <Typography color='primary' variant='h6'>#{params.row?.original?.index}</Typography>
                                                </Link>
                                            ),
                                            size: 30,
                                        },
                                        {
                                            accessorKey: "risk",
                                            header: "Risk",

                                            size: 30,
                                        },
                                        {
                                            accessorKey: "projectName",
                                            header: "Project",
                                            size: 100,
                                            Cell: (params: any) => <TruncatedScrollingText
                                                name={params?.row?.original?.projectName}
                                                typographyVariant='body2'
                                            />
                                        },


                                        {
                                            accessorKey: "assetName",
                                            header: "Asset",
                                            size: 100,
                                            Cell: (params: any) => {
                                                const path = ROUTES.PROJECT.replace(':projectId', params?.row?.original?.projectId) + `?assetid=${params?.row?.original?.assetId}`;
                                                return (
                                                    <Box>
                                                        <Link className="hand">
                                                            <TruncatedScrollingText
                                                                name={params?.row?.original?.assetName}
                                                                typographyVariant='body2'
                                                                sx={{ fontWeight: "bold", color: "primary.text" }}
                                                                onClick={() => navigate.push(path)}
                                                            />
                                                            <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "12px" }}>
                                                                {params?.row?.original?.operationId}
                                                            </Typography>
                                                        </Link>
                                                    </Box>
                                                )
                                            }


                                        },
                                        { accessorKey: "faultId", header: "Fault Id", size: 50 },

                                        { accessorKey: "findingName", header: "Name", size: 30 },
                                        {
                                            accessorKey: "duration",
                                            header: "Open for",


                                        },

                                        {
                                            accessorKey: "faultGroup",
                                            header: "Fault Group",

                                            Cell: (params: any) => (
                                                <FaultGroups faultGroupArray={params?.row?.original?.faultGroup?.split(',')} />
                                            )

                                        },
                                        {
                                            accessorKey: "environmentName",
                                            header: "Environment",
                                            size: 50,

                                        },
                                        {
                                            accessorKey: "state",

                                            header: "State",
                                            size: 30,

                                        },
                                        {
                                            accessorKey: "status",

                                            header: "Status",
                                            size: 60,

                                            Cell: (params: any) => {
                                                let status = params?.row?.original?.status;
                                                let statusLabel = ISSUE_STATE_OPTIONS.find((x: any) => x.key === status)?.label
                                                return (
                                                    <>
                                                        {statusLabel === "Assigned" ? (<>
                                                            <UserCircle
                                                                fontSize="small"
                                                                sx={{
                                                                    display: "inline",
                                                                    position: "relative",
                                                                    top: "4px",
                                                                }}
                                                            />{" "}
                                                            <Box sx={{ display: "inline" }}>
                                                                {params?.row?.original?.assignee?.firstName} {params?.row?.original?.assignee?.lastName}
                                                            </Box>
                                                        </>) : (statusLabel)}
                                                    </>
                                                )
                                            },


                                        },

                                    ]}
                                    data={rows}


                                    initialState={{
                                        density: "compact",
                                        columnPinning: { left: ['id'] },
                                    }}
                                    enableColumnActions={false}
                                    enableSorting={false}
                                    enableStickyHeader
                                    enablePagination={false}
                                    enableDensityToggle={false}
                                    enableColumnFilters={false}
                                    enableTopToolbar={false}
                                    state={{

                                        showProgressBars: isFetching,
                                    }}

                                    muiTableContainerProps={{
                                        ref: tableContainerRef, //get access to the table container element
                                        sx: { maxHeight: maxHeight }, //give the table a max height
                                        onScroll: (
                                            event: UIEvent<HTMLDivElement> //add an event listener to the table container element
                                        ) => {


                                            if (!disableInfiniteScroll) {
                                                fetchMoreOnBottomReached(event.target as HTMLDivElement)
                                            }

                                        }

                                    }}
                                />
                            </Box>
                        </Box>
                </Container>
            </Box>
        
    );
};

export default IssueReport;